import React from 'react';

export default function IconDialogError({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM14.7875 10.8026C14.7402 10.0978 15.2991 9.5 16.0056 9.5C16.7079 9.5 17.2654 10.0911 17.2243 10.7922L16.8097 17.8702C16.7857 18.28 16.4464 18.6 16.0359 18.6C15.628 18.6 15.2899 18.2838 15.2626 17.8768L14.7875 10.8026ZM16 22.4999C16.718 22.4999 17.3 21.9179 17.3 21.1999C17.3 20.482 16.718 19.8999 16 19.8999C15.282 19.8999 14.7 20.482 14.7 21.1999C14.7 21.9179 15.282 22.4999 16 22.4999Z"
        fill="#F69113"
      />
    </svg>
  );
}
